export const getAvatarImage = (image: string) => {
  if (image.includes('https://')) {
    return image
  }
  return `https://ik.imagekit.io/ikdeboss/${image}?tr=n-media_library_thumbnail`
}
